import React, { useState } from 'react';
import { Modal, Form, Input } from "antd";
import { PASSWORD_PATTERN, EMAIL_PATTERN} from "../utils/regex";
import { createUser } from './../services/authService';

function UserForm({ visible, onCancel, onCreate, onValidUsername }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const okHandler = () => {
        form.validateFields().then(async values => {
            setLoading(true);

            try {
                const { data } = await createUser(values);
                form.resetFields();
                onCreate(data);
            } catch (error) {}
            finally {
                setLoading(false);
            }
        }).catch(() => {});
    };

    const cancelHandler = () => {
        form.resetFields();
        onCancel();
    };

    return (<Modal visible={visible} title="Nuevo usuario"
        onCancel={cancelHandler}
        confirmLoading={loading}
        onOk={okHandler}>
        <Form form={form} layout="vertical">
            <Form.Item name="userName" extra="Nombre de usuario debe ser un dirección de correo."
                rules={[
                    { required: true, message: 'Nombre de usuario no debe ser vacío' },
                    { pattern: EMAIL_PATTERN, message: 'Nombre de usuario no es una dirección de correo' },
                    { validator: (_, value) => onValidUsername(value) ? Promise.resolve() : Promise.reject(new Error('Ya existe un usuario con ese nombre')) }
                ]}>
                <Input placeholder="Nombre" />
            </Form.Item>
            <Form.Item name="password" extra="La contraseña debe tener al menos 8 caracteres y cumplir con 3 de lo siguiente: mayúsculas, minúsculas, número y/o carácter especial (!@#$%^&*)."
                rules={[
                    { required: true, message: 'Contraseña no debe ser vacía' },
                    { pattern: PASSWORD_PATTERN, message: 'La contraseña no cumple con el criterio' }
                ]}>
                <Input.Password placeholder="Contraseña" />
            </Form.Item>
        </Form>
    </Modal>);
}

export default UserForm;


// WEBPACK FOOTER //
// ./src/components/UserForm.jsx